import {adminHttpClient} from "../../../commons/adminHttpClinet";
import {CashbackStatisticsModel} from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";

const getCashbackStatistics = () : Promise<CashbackStatisticsModel> => {
    return adminHttpClient.get(`/api/Admin/AdminStatistics/cashback-statistics`);
}

export default getCashbackStatistics;